<div class="reports-panel" *ngIf="report && report.visible"
    [ngClass]="[report.noBottomMargin ? 'remove-bottom-margin' : 'add-bottom-margin']"
    [attr.data-automation-id]="report.automationId + '-container'" id="{{report.automationId}}">
    <div *ngIf="report.reportType !== reportTypes.WORKFLOW">
        <div class="report-title-bar" *ngIf="report.headerBarVisible">
            <span [attr.data-automation-id]="report.automationId + '-title-label'">{{report.name}}</span>

            <ul class="nav nav-tabs" *ngIf="tabsBarVisible()">
                <li [ngClass]="{'active': chartBySize, 'disabled': (!report.data.reportType || (report.data.formatedData && report.data.formatedData.length === 0)) }"
                    [attr.data-automation-id]="report.automationId + '-report-tab-by-size'"
                    (click)="selectTab(chartBySize)">
                    <a
                        [ngClass]="{'disabled': (!report.data.reportType || (report.data.formatedData && report.data.formatedData.length === 0)) }">By
                        Size</a>
                </li>
                <li [ngClass]="{'active': !chartBySize, 'disabled': (!report.data.reportType || (report.data.formatedData && report.data.formatedData.length === 0)) }"
                    [attr.data-automation-id]="report.automationId + '-report-tab-by-count'"
                    (click)="selectTab(chartBySize)">
                    <a
                        [ngClass]="{'disabled': (!report.data.reportType || (report.data.formatedData && report.data.formatedData.length === 0)) }">By
                        Count</a>
                </li>
            </ul>

            <div class="report-toolbar-dropdown"
                [ngClass]="{'disabled': (disableReportDownload && report?.reportType === 'SEARCH') || (report?.reportType === reportTypes.SEARCH && report.data.hits && report.data.hits==='0') || (!report.data.reportType ||
             (report.data.formatedData && report.data.formatedData.length === 0 && report.reportType !== reportTypes.SEARCH))}">
                <div (click)="downloadFile(report.reportType, report.downloadReportExtension)"
                    *ngIf="((report.reportType === reportTypes.SEARCH && report.isDownloadButtonPresent && isQuerySectionVisible()) || (report.reportType !== reportTypes.SEARCH && report.isDownloadButtonPresent)) &&  hasDownloadPermission"
                    [title]="report.downloadTooltip"
                    [attr.data-automation-id]="report.automationId + '-download-button'">
                    <i class="fa fa-download"></i>
                    <div class="action-text" [class.hidden]="hiddenActionText">Download</div>
                </div>
                <div [attr.data-automation-id]="report.automationId + '-details-button'"
                    *ngIf="report.isDetailsButtonPresent" (click)="openDetailsModal(report.detailsType)">
                    <i class="fa fa-th-list"></i>
                    <div class="action-text" [class.hidden]="hiddenActionText">Details</div>
                </div>
                <div [attr.data-automation-id]="report.automationId + '-zero-day-details-button'"
                    *ngIf="report.isZeroDayDetailsButtonPresent" (click)="openDetailsModal('ZERO_DAY_DETAILS')">
                    <i class="fa fa-calendar-times-o"></i>
                    <div class="action-text" [class.hidden]="hiddenActionText">Zero Day Details</div>
                </div>
            </div>

        </div>
        <div class="report-panel-content"
            [resBusySpinner]="report && report.isBusy !== undefined ? report.isBusy : false" [message]="isBusyMessage"
            [ngStyle]="{'min-height': report.reportType === reportTypes.SEARCH || report.reportType === reportTypes.METADATA_BULK_SEARCH_SUMMARY ? '110px' : '320px'}">
            <div class="search-summary-panel" *ngIf="report.reportType === reportTypes.SEARCH">
                <div class="search-summary-left-panel" #leftSection
                    [ngClass]="[report.data.searchType === searchTypes.BULK ? 'fixed-width' : isQuerySectionVisible() ? 'report-40-width' : 'report-full-width']">
                    <div class="search-summary-line" *ngIf="report.data.searchType !== searchTypes.BULK">
                        <div class="search-summary-label">Search Type:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-search-type-label'">
                            {{report.data.searchType}}</div>
                    </div>
                    <div class="search-summary-line" *ngIf="report.data.searchType !== searchTypes.BULK">
                        <div class="search-summary-label">Target:</div>
                        <div class="search-summary-data"><span class="target-name-field"
                                [attr.data-automation-id]="report.automationId + '-target-label'">{{report.data.targetName}}</span>
                        </div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="!report.data.isWorkflowStepSearchResult && (report.data.searchType === searchTypes.FREEFORM || report.data.searchType === searchTypes.ADVANCED || report.data.searchType === searchTypes.COMBINED)">
                        <div class="search-summary-label">Filter by Data Sets:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-filter-by-data-sets-label'">
                            {{report.data.sources}}</div>
                    </div>
                    <div class="search-summary-line" *ngIf="report.data.searchType === searchTypes.SAMPLE_BY_SIZE">
                        <div class="search-summary-label">% of Documents:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-percent-of-documents-label'">
                            {{report.data.percentOfDocuments}}</div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType === searchTypes.SAMPLE_BY_CONFIDENCE_LEVEL">
                        <div class="search-summary-label">Confidence Level:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-confidence-level-label'">
                            {{report.data.confidenceLevel}}</div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType === searchTypes.SAMPLE_BY_CONFIDENCE_LEVEL">
                        <div class="search-summary-label">Margin of Error:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-margin-of-error-label'">
                            {{report.data.marginOfError}}</div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType === searchTypes.FREEFORM || report.data.searchType === searchTypes.ADVANCED ||
                                                            report.data.searchType === searchTypes.COMBINED || report.data.searchType === searchTypes.SAMPLE_BY_SIZE || 
                                                            report.data.searchType === searchTypes.SAMPLE_BY_CONFIDENCE_LEVEL || report.data.searchType === searchTypes.BULK">
                        <div class="search-summary-label">Include Families:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-include-families-icon'">
                            <i *ngIf="report.data.includeFamilies" class="fa fa-check fa-icon"></i>
                            <i *ngIf="!report.data.includeFamilies" class="fa fa-close fa-icon"></i>
                        </div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType === searchTypes.FREEFORM || report.data.searchType === searchTypes.ADVANCED || report.data.searchType === searchTypes.COMBINED || report.data.searchType === searchTypes.BULK">
                        <div class="search-summary-label">Include Metadata:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-include-metadata-icon'">
                            <i *ngIf="report.data.includeMetadata" class="fa fa-check fa-icon"></i>
                            <i *ngIf="!report.data.includeMetadata" class="fa fa-close fa-icon"></i>
                        </div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType === searchTypes.ADVANCED || report.data.searchType === searchTypes.COMBINED || report.data.isBulkSearchNode || report.data.searchType === searchTypes.BULK">
                        <div class="search-summary-label">Expand Synonyms:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-expand-synonyms-icon'">
                            <i *ngIf="report.data.synonymExpansion" class="fa fa-check fa-icon"></i>
                            <i *ngIf="!report.data.synonymExpansion" class="fa fa-close fa-icon"></i>
                        </div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType === searchTypes.NEAR_DUPLICATE_DOCUMENT || report.data.searchType === searchTypes.MORE_LIKE_THESE
                                                            || report.data.searchType === searchTypes.BY_SYNTHETIC_DOCUMENT">
                        <div class="search-summary-label">Threshold:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-threshold-label'">
                            {{report.data.threshold}}</div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType === searchTypes.NEAR_DUPLICATE_DOCUMENT || report.data.searchType === searchTypes.EXACT_DUPLICATE_DOCUMENT ||
                                                            report.data.searchType === searchTypes.CONTENT_DUPLICATE_DOCUMENT">
                        <div class="search-summary-label">Source Document:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-source-document-label'">
                            {{report.data.filenameEntered}}</div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType === searchTypes.BY_SYNTHETIC_DOCUMENT">
                        <div class="search-summary-label">Source Synthetic Document:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-source-synthetic-document-label'">
                            {{report.data.filenameEntered}}</div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType !== searchTypes.SAMPLE_BY_SIZE && report.data.searchType !== searchTypes.SAMPLE_BY_CONFIDENCE_LEVEL && report.data.searchType !== searchTypes.BULK">
                        <div class="search-summary-label">Results:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-results-label'">
                            {{report.data.hits}}</div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType === searchTypes.SAMPLE_BY_SIZE || report.data.searchType === searchTypes.SAMPLE_BY_CONFIDENCE_LEVEL">
                        <div class="search-summary-label">Sample All Custodians:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-sample-all-custodians-icon'">
                            <i *ngIf="report.data.sampleAllCustodians" class="fa fa-check fa-icon"></i>
                            <i *ngIf="!report.data.sampleAllCustodians" class="fa fa-close fa-icon"></i>
                        </div>
                    </div>
                    <div class="search-summary-line"
                        *ngIf="report.data.searchType === searchTypes.SAMPLE_BY_SIZE || report.data.searchType === searchTypes.SAMPLE_BY_CONFIDENCE_LEVEL">
                        <div class="search-summary-label">Results / Sample Size:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-results-sample-size-label'">
                            {{report.data.resultsSampleSize}}</div>
                    </div>
                </div>

                <div *ngIf="isQuerySectionVisible()" class="search-summary-right-panel" #rightSection>
                    <ul class="nav nav-tabs">
                        <li [ngClass]="{'active': queryType === 'entered' }"
                            [attr.data-automation-id]="report.automationId + '-query-entered-tab'"
                            (click)="setQueryType('entered')">
                            <a>Query Entered</a>
                        </li>
                        <li [ngClass]="{'active': queryType === 'executed' }"
                            [attr.data-automation-id]="report.automationId + '-query-executed-tab'"
                            (click)="setQueryType('executed')">
                            <a>Query Executed</a>
                        </li>
                    </ul>
                    <div class="content">
                        <div class="colorized-div" *ngIf="queryType === 'entered'">
                            <span class="colorized-span colorized-container" [attr.query]="queryEntered"
                                [attr.data-automation-id]="report.automationId + '-query-entered'"
                                [innerHTML]="colorizedQueryEntered"></span>
                        </div>
                        <div class="colorized-div" *ngIf="queryType === 'executed'">
                            <span class="colorized-span colorized-container" [attr.query]="queryExecuted"
                                [attr.data-automation-id]="report.automationId + '-query-executed'"
                                [innerHTML]="colorizedQueryExecuted"></span>
                        </div>
                    </div>
                </div>
                <div *ngIf="report.data.searchType === searchTypes.BULK"
                    class="search-summary-left-panel report-full-width">
                    <div class="search-summary-line">
                        <div class="search-summary-label">Run Date:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-run-date-label'">
                            {{runDate}}</div>
                    </div>
                    <div class="search-summary-line">
                        <div class="search-summary-label">Target:</div>
                        <div class="search-summary-data">
                            <span class="target-name-field"
                                [attr.data-automation-id]="report.automationId + '-target-label'">{{report.data.targetName}}</span>
                        </div>
                    </div>
                    <div class="search-summary-line">
                        <div class="search-summary-label">Filter by Data Sets:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-filter-by-data-sets-label'">
                            {{report.data.sources}}</div>
                    </div>
                    <div class="search-summary-line" *ngIf="report.data.connectorName">
                        <div class="search-summary-label">Connector Name:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-input-file-label'">
                            {{report.data.connectorName}}</div>
                    </div>
                    <div class="search-summary-line">
                        <div class="search-summary-label">Input File:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-input-file-label'">
                            {{report.data.inputFile}}</div>
                    </div>
                    <div class="search-summary-line" *ngIf="report.data.bulkSearchChunkSize">
                        <div class="search-summary-label">Chunk Size:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-input-file-label'">
                            {{report.data.bulkSearchChunkSize}}</div>
                    </div>
                </div>
            </div>
            <div class="search-summary-panel" *ngIf="report.reportType === reportTypes.METADATA_BULK_SEARCH_SUMMARY">
                <div class="search-summary-left-panel report-half-width">
                    <div class="search-summary-line">
                        <div class="search-summary-label">Search Type:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-search-type-label'">
                            {{report.data.searchType}}</div>
                    </div>
                    <div class="search-summary-line">
                        <div class="search-summary-label">Target:</div>
                        <div class="search-summary-data"><span class="target-name-field"
                                [attr.data-automation-id]="report.automationId + '-target-label'">{{report.data.targetName}}</span>
                        </div>
                    </div>
                    <div class="search-summary-line">
                        <div class="search-summary-label">Input File:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-input-file-label'">
                            {{report.data.inputFile}}</div>
                    </div>
                    <div class="search-summary-line">
                        <div class="search-summary-label">Metadata Field:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-metadata-field-label'">
                            {{report.data.metadataField}}</div>
                    </div>
                    <div class="search-summary-line">
                        <div class="search-summary-label">Include Families:</div>
                        <div class="search-summary-data"
                            [attr.data-automation-id]="report.automationId + '-include-families-icon'">
                            <i *ngIf="report.data.includeFamilies" class="fa fa-check fa-icon"></i>
                            <i *ngIf="!report.data.includeFamilies" class="fa fa-close fa-icon"></i>
                        </div>
                    </div>
                </div>
                <div class="metadata-bulk-search-right-table report-half-width">
                    <div class="table-header table-row">
                        <div class="table-cell first-column">Result Category</div>
                        <div class="table-cell second-column">Count</div>
                    </div>
                    <div class="table-row odd-row">
                        <div class="table-cell first-column">Provided</div>
                        <div class="table-cell second-column">{{report.data.providedValues}}</div>
                    </div>
                    <div class="table-row even-row">
                        <div class="table-cell first-column">Matched</div>
                        <div class="table-cell second-column">{{report.data.matchedValues}}</div>
                    </div>
                    <div class="table-row odd-row">
                        <div class="table-cell first-column">Not Matched</div>
                        <div class="table-cell second-column">{{report.data.missedValues}}</div>
                    </div>
                    <div class="table-row even-row">
                        <div class="table-cell first-column">Multiple Matches</div>
                        <div class="table-cell second-column">{{report.data.multipleMatchedValues}}</div>
                    </div>
                </div>
            </div>
            <div *ngIf="report.reportDisplayType === reportDisplayType.GRID && !report.isDisabled"
                class="report-grid-container">
                <res-generic-grid #reportGrid
                    *ngIf="report.data.formatedData && report.data.formatedData.length > 0 && columnDefs"
                    [style.height]="report.reportType === reportTypes.SEARCH && report.name === 'Search Summary' ? 'calc(100vh - 331px)' : '320px'"
                    gridName="Report Grid" [automationId]="report.automationId" [columnDefs]="columnDefs"
                    [rowSelection]="rowSelection" [initialData]="report.data.formatedData"
                    [loadDataFinishedCallback]="loadDataFinishedCallback" [gridContext]="report.gridContext"
                    [responseArrayCallback]="responseArrayCallback" [contextMenuOptions]="contextMenuOptions"
                    [onSelectionChanged]="onSelectionChanged"
                    [headerHeight]="report.reportType === reportTypes.TERM_SEARCH_HIT_COUNT ? 40 : null"
                    [pinnedRow]="report.data.pinnedRow" [pagerVisible]="false"
                    [cellDoubleClickedCallback]="cellDoubleClickedCallback" [rowClassRules]="rowClassRules"
                    [cellClickedCallback]="cellClickedCallback">
                </res-generic-grid>
            </div>

            <div class="chart-content-pie"
                *ngIf="report.reportDisplayType === reportDisplayType.PIE_CHART && report.data.reportEntryList && report.data.reportEntryList.length > 0"
                [resBusySpinner]="isChartBusy" [message]="isChatBusyMessage">
                <div class="left-content-pie">
                    <div class="chart-container-pie" [attr.data-automation-id]="report.automationId + '-pie-chart'">
                        <canvas id="{{uniqueId}}" height="320"></canvas>
                    </div>
                </div>
                <div *ngIf="report.reportDisplayType === reportDisplayType.PIE_CHART" class="legend-content"
                    id="{{uniqueId}}-legend" [attr.data-automation-id]="report.automationId + '-pie-chart-legend'">
                </div>
            </div>
            <div class="chart-content-bar" [class.range-picker-grid]="report.isZeroDayDetailsButtonPresent"
                *ngIf="report.reportDisplayType === reportDisplayType.BAR_CHART && report.data.reportEntryList && report.data.reportEntryList.length > 0"
                [resBusySpinner]="isChartBusy" [message]="isChatBusyMessage" id="chart-container_{{report.index}}">
                <div class="top-content-bar collapse"
                    *ngIf="report.reportType === 'DATE_EMAIL_RECEIVED' || report.reportType === 'DATE_EMAIL_SENT' || report.reportType === 'DATE_PRIMARY'">
                    <div class="date-range-picker minimum-width">
                        <span class="range-indicator">Date Range:</span>
                        <div class="date-rang-panel">
                            <res-custom-date-time-picker class="date-time-picker" name="dateStart" ngDefaultControl
                                [inputPlaceholder]="defaultDatePlaceholders[0]" (focusout)="compareDateRange()"
                                [(ngModel)]="startDate" (ngModelChange)="compareDateRange()" [isDateRange]="true"
                                [hasErrorMessage]="dateError" [isStart]="true" [isEnd]="false"
                                (click)="compareDateRange()"
                                [automationId]="modalAutomationId + '-start-date-time-picker'">
                            </res-custom-date-time-picker>
                            <div class="picker-separator">~~</div>
                            <res-custom-date-time-picker class="date-time-picker" name="dateEnd" ngDefaultControl
                                [inputPlaceholder]="defaultDatePlaceholders[1]" (focusout)="compareDateRange()"
                                [(ngModel)]="endDate" (ngModelChange)="compareDateRange()" [isDateRange]="true"
                                [hasErrorMessage]="dateError" [isStart]="false" [isEnd]="true"
                                (click)="compareDateRange()"
                                [automationId]="modalAutomationId + '-end-date-time-picker'">
                            </res-custom-date-time-picker>
                        </div>
                        <div class="apply-reset-buttons">
                            <button type="button"
                                [attr.data-automation-id]="report.automationId + '-bar-chart-histogram-apply-button'"
                                class="primary-button" title="{{!labelVisible() ? 'Apply' : ''}}"
                                (click)="applyHistogramPeriod()" [disabled]='dateError || !startDate || !endDate'
                                [ngClass]="{'thin-button': labelVisible() ? false : true}">
                                <i class="fa fa-check"></i>
                                <span *ngIf="labelVisible()">Apply</span>
                            </button>
                            <button type="button"
                                [attr.data-automation-id]="report.automationId + '-bar-chart-histogram-reset-button'"
                                class="secondary-button" title="{{!labelVisible() ? 'Reset' : ''}}"
                                (click)="resetHistogramPeriod()" [disabled]='dateError || !startDate || !endDate'
                                [ngClass]="{'thin-button': labelVisible() ? false : true}">
                                <i class="fa fa-rotate-left"></i>
                                <span *ngIf="labelVisible()">Reset</span>
                            </button>
                        </div>
                    </div>
                    <div class="next-previous-section">
                        <button type="button"
                            [attr.data-automation-id]="report.automationId + '-bar-chart-histogram-previous-period-button'"
                            class="secondary-button margin-left-previous-button"
                            (click)="getReportDetailsForPeriod('previous')"
                            title="{{!labelVisible() ? 'Previous Period' : ''}}"
                            [disabled]='dateError || !startDate || !endDate'
                            [ngClass]="{'thin-button': labelPeriodVisible() ? false : true}">
                            <i class="fa fa-chevron-circle-left color-grey-10"></i>
                            <span *ngIf="labelPeriodVisible()">Previous Period</span>
                        </button>
                        <button type="button"
                            [attr.data-automation-id]="report.automationId + '-bar-chart-histogram-next-period-button'"
                            class="secondary-button margin-left-next-button" (click)="getReportDetailsForPeriod('next')"
                            title="{{!labelVisible() ? 'Next Period' : ''}}"
                            [disabled]='dateError || !startDate || !endDate'
                            [ngClass]="{'thin-button': labelPeriodVisible() ? false : true}">
                            <span *ngIf="labelPeriodVisible()">Next Period</span>
                            <i class="fa fa-chevron-circle-right color-grey-10 margin-left-next-icon"></i>
                        </button>
                    </div>
                </div>
                <div class="chart-container-bar" [attr.data-automation-id]="report.automationId + '-bar-chart'"
                    id="chart-container_{{report.index}}">
                    <canvas id="{{uniqueId}}"
                        [ngClass]="[report.isFullWidth ? 'bar-canvas-full-width' : 'bar-canvas-half-width']"></canvas>
                </div>
                <span class="tooltip-drill-histogram" *ngIf="report.isZeroDayDetailsButtonPresent">
                    <span class="tooltip-drill-histogram-span" id="tooltip-drill-histogram-text_{{report.index}}">
                        <span>Click to drill down.</span><br /><span>Double-click to drill through.</span>
                    </span>
                </span>
            </div>

            <div *ngIf="showNoDataOrDisabledPanel(report)" class="no-data-or-disabled-panel"
                [attr.data-automation-id]="report.isDisabled ? 'disabled-report' : 'no-data-report'"
                [ngClass]="[report.node.name === 'Dashboard' ? (!commonService.dashboardReportsEnabled ? 'disabled-color' : 'no-data-color' ) : (report.isDisabled ? 'disabled-color' : 'no-data-color')]">
                <span *ngIf="report.node.name === 'Dashboard'">
                    {{!commonService.dashboardReportsEnabled ? "Report Disabled" : "No Data to Display"}}
                </span>
                <span *ngIf="report.node.name !== 'Dashboard'">
                    {{report.isDisabled ? "Report Disabled" : "No Data to Display"}}
                </span>
            </div>
        </div>

    </div>
    <div *ngIf="report.reportType === reportTypes.WORKFLOW && workflow" class="workflow-reports">
        <div class="workflow-report-name-description">
            <div class="workflow-name">
                <span class="workflow-name-span" [attr.data-automation-id]="'workflow-name'">{{workflow.name}}</span>
            </div>
            <span class="workflow-description" *ngIf="workflow && workflow.description"
                [attr.data-automation-id]="'workflow-description'">{{workflow.description}}</span>
        </div>
        <div class="workflow-report-pane">
            <div class="workflow-info-pane" [ngClass]="[checkScroll() ? 'workflow-info-pane-scroll' : '']"
                [attr.data-automation-id]="'workflow-info-pane-container'">
                <div class="upper-pane-left input-indicator">
                    <div class="input-row"><span class="label-indicator">Last run: </span> <span class="value-indicator"
                            [attr.data-automation-id]="'workflows-steps-last-run'">{{
                            (workflow.lastExecutedOn | date:'yyyy-MM-dd HH:mm:ss') }}</span></div>
                    <div class="input-row"><span class="label-indicator">Target Docs: </span> <span
                            class="value-indicator"
                            [attr.data-automation-id]="'workflows-steps-target-docs'">{{workflow.targetcount}}</span>
                    </div>
                    <div class="input-row"><span class="label-indicator">Culled Docs: </span> <span
                            class="value-indicator"
                            [attr.data-automation-id]="'workflows-steps-culled-docs'">{{workflow.culledcount}}</span>
                    </div>
                    <div class="input-row"><span class="label-indicator">Results: </span> <span class="value-indicator"
                            [attr.data-automation-id]="'workflows-steps-results'">{{workflow.resultcount}}</span></div>
                </div>
                <div class="upper-pane-right input-indicator">
                    <div class="input-row"><span class="label-indicator">Target: </span> <span class="value-indicator"
                            [attr.data-automation-id]="'workflows-steps-target'">{{workflow.targetname}}</span></div>
                    <!-- <div><span class="label-indicator">Filter by Data Set/s: </span> <span class="value-indicator">NA - ST WORK</span></div> -->
                    <div class="input-row">
                        <span class="label-indicator">Tag/s:</span>
                        <span *ngIf="workflow.tagItem">
                            <span *ngFor="let tag of workflow.tagItem.taggedEntityList; index as i;  let isLast=last"
                                class="icon-indicator">
                                <i class="fa fa-tag" [ngStyle]="{'color': tag.displayValue}" [title]="tag.name"
                                    attr.data-automation-id="workflows-steps-tag-{{i + 1}}"></i>
                                {{tag.name}}{{isLast ? '' : '; '}}
                            </span>
                        </span>
                    </div>
                    <div class="input-row">
                        <span class="label-indicator">Folder: </span>
                        <span class="value-indicator icon-indicator" *ngIf="workflow.folderItem">
                            <i class="fa fa-folder"
                                [ngStyle]="{'color': workflow.folderItem && workflow.folderItem.displayValue}"
                                [title]="workflow.folderItem.name"
                                [attr.data-automation-id]="'workflows-steps-folder'"></i>
                            {{workflow.folderItem.name}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="workflow-steps-pane" id="stepsPane">
                <div class="workflow-steps">
                    <div class="workflow-steps-pane-content"
                        *ngFor="let report of report.data.reportEntries; index as i"
                        attr.data-automation-id="Workflow-term-query-step-{{i + 1}}-container">
                        <div class="steps-pane-header">Step {{i + 1}} - {{report.query.steptype}}</div>
                        <div class="steps-pane-query">
                            <div class="query">
                                <span title="{{report.query.stepquery}}" class="colorized-container"
                                    [innerHTML]="report.colorized" [attr.query]="report.query.stepqueryDisplayed"
                                    attr.data-automation-id="Workflows-Step-{{i + 1}}-query-input"></span>
                            </div>
                            <div class="description input-indicator" *ngIf="report.query.stepdescription"><span
                                    class="label-indicator">Description:
                                </span>
                                <span class="value-indicator">{{report.query.stepdescription}}</span>
                            </div>
                        </div>
                        <div class="steps-pane-grid"
                            [ngClass]="[report.data.length === 3 ? 'steps-pane-grid-small' : 'steps-pane-grid-bottom-border']">
                            <res-generic-grid gridName="Workflows Step {{i + 1}}"
                                [automationId]="'Workflows Step ' + (i + 1)" [columnDefs]="columnDefs"
                                [rowSelection]="rowSelection" [initialData]="report.data" [pagerVisible]="false"
                                [responseArrayCallback]="responseArrayCallback"
                                [onSelectionChanged]="onSelectionChanged">
                            </res-generic-grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>